// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Sn0x"};